import { createFeatureSelector } from '@ngrx/store';

export const paymentState = createFeatureSelector<OLO.State, OLO.State.Payment>('payment');
